module.exports = __webpack_public_path__ + "static/media/autodesk-logo.da57cfc7.svg";